import React, { useState } from "react";
import "./Modal.css";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Modal = ({ setOpenModal, title, children, cancelBtn="Cancel", submitBtn="Submit", submitClkEvent=null, cancelClkEvent = null, titleSize = "calc(1.275rem + .3vw)", isCrossMarkTheSameCancelBtn = true}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleCancelClick = () => {
    if (cancelClkEvent) {
      cancelClkEvent();
    }
    setOpenModal(false);
  };

  const handleXmarkClick = () => {
    if (!isSubmitting) {
      if (isCrossMarkTheSameCancelBtn) {
        handleCancelClick();
      } else {
        setOpenModal(false);
      }
    }
  };

  const handleSubmitClick = () => {
    if (submitClkEvent && !isSubmitting) {
      setIsSubmitting(true);
      submitClkEvent();
    }
  }

  return (
    <>
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="modal-header">
            <div className="modal-title" style={{fontSize: titleSize}}>{title}</div>
            <div className="titleCloseBtn">
              <FontAwesomeIcon
                icon={faXmark}
                className="xmark-icon"
                size="2x"
                onClick={handleXmarkClick}
              />
            </div>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <button
              onClick={handleCancelClick}
              className="cancelBtn"
              type="button"
              disabled={isSubmitting}
            >
              {cancelBtn}
            </button>
            <button
              className="submit"
              onClick={handleSubmitClick}
              disabled={isSubmitting}
            >
              {submitBtn}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
